import Close from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { t } from 'i18next';

import { MatchKey } from '~hooks/useMatchKeys/models';

import { parseMatchKey } from './matchKeyFormat';

interface MatchKeyListProps {
  canDeleteMatchKey: boolean;
  matchKeys: MatchKey[];
  onDeleteMatchKey: (matchKey: MatchKey) => void;
}

export default function MatchKeyList({
  canDeleteMatchKey,
  matchKeys,
  onDeleteMatchKey,
}: MatchKeyListProps) {
  if (matchKeys.length === 0) {
    return (
      <Typography sx={{ color: 'text.secondary', px: 2, py: 1.5 }}>
        {t('administration.match_keys.no_match_keys')}
      </Typography>
    );
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, px: 2, py: 1.5 }}>
      {matchKeys.map((matchKey) => {
        const { source, value } = parseMatchKey(matchKey.key);

        return (
          <Box
            key={matchKey.id}
            sx={{ alignItems: 'center', display: 'flex', gap: 1.5 }}
            data-ui={`match-keys__key__${matchKey.id}`}
          >
            {source && <Chip label={source} size="small" />}

            <Typography sx={{ flexGrow: 1 }}>{value}</Typography>

            {canDeleteMatchKey && (
              <IconButton
                aria-label={t('actions.delete')}
                data-ui={`match-keys__key__${matchKey.id}__delete-button`}
                onClick={() => onDeleteMatchKey(matchKey)}
                size="small"
              >
                <Close fontSize="small" />
              </IconButton>
            )}
          </Box>
        );
      })}
    </Box>
  );
}
